// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb2fc14f","242":"538ad2bc","455":"4cd3a16a","679":"c99d261c"}[chunkId] + ".chunk.js";
};